// Types pour le suivi des traitements en cours

export type ProcessingStatus =
  | 'inprogress'
  | 'analysed'
  | 'analyzing'
  | 'scoring'
  | 'analyzing_strengths'
  | 'generating_recommendations'
  | 'qualified'
  | 'completed'
  | 'searching'
  | 'streaming'
  | 'error'
  | 'idle'
  // Enhanced analysis specific statuses
  | 'checking'
  | 'partial';

export type ProcessingType = 'analysis' | 'job_search';

export interface ActiveProcessItem {
  id: string;
  type: ProcessingType;
  name: string;
  progress?: number;
}

export interface ProcessingTrackerState {
  analysisCount: number;        // Nombre d'analyses en cours
  jobSearchCount: number;       // Nombre de recherches en cours
  hasCompletedAnalysis: boolean; // Au moins une analyse terminée non consultée
  hasCompletedJobSearch: boolean; // Au moins une recherche terminée non consultée
  hasActiveProcesses: boolean;   // Au moins un traitement actif
  justCompletedAnalysis: boolean; // Une analyse vient de se terminer (transition)
  justCompletedJobSearch: boolean; // Une recherche vient de se terminer (transition)
  activeItems: ActiveProcessItem[]; // Détails des traitements actifs
}

// Statuts considérés comme "en cours" pour les analyses
export const ACTIVE_ANALYSIS_STATUSES: ProcessingStatus[] = [
  'inprogress',
  'analysed',
  'analyzing',
  'scoring',
  'analyzing_strengths',
  'generating_recommendations',
  // Enhanced analysis specific
  'checking',
  'partial',
];

// Statuts considérés comme "en cours" pour les recherches
export const ACTIVE_JOB_SEARCH_STATUSES: ProcessingStatus[] = [
  'searching',
  'streaming',
];

// Statuts considérés comme "terminés" pour les analyses
export const COMPLETED_ANALYSIS_STATUSES: ProcessingStatus[] = [
  'qualified',
  'completed',
];

// Statuts considérés comme "terminés" pour les recherches
export const COMPLETED_JOB_SEARCH_STATUSES: ProcessingStatus[] = [
  'completed',
];
